export const VALUE_CONFLICT_ROLES = ['financial'];

export const MARGIN_EXCEPTION_ROLES = ['admin', 'financial'];

export const PRICE_EDIT_ROLES = ['financial'];

export const hasAnyRole = (roles = [], allowed = []) => roles.some((role) => allowed.includes(role?.name || role));
